import { render, staticRenderFns } from "./Election.vue?vue&type=template&id=0a2c3e7c&scoped=true"
import script from "./Election.vue?vue&type=script&lang=js"
export * from "./Election.vue?vue&type=script&lang=js"
import style0 from "./Election.vue?vue&type=style&index=0&id=0a2c3e7c&prod&scoped=true&lang=css"
import style1 from "./Election.vue?vue&type=style&index=1&id=0a2c3e7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2c3e7c",
  null
  
)

export default component.exports